import type { Address } from '../types/common';

/** Electroz works only in Maharashtra for now: every address and bill uses this state (CGST + SGST). */
export const HOME_STATE = { state: 'Maharashtra', stateCode: '27' } as const;

/** Adds the home state to an address before saving it. */
export const withHomeState = <T extends Address>(address: T = {} as T): T => ({ ...address, ...HOME_STATE });
